import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const FastSearch = () => {
    document.title = "Sürətli axtarış";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common" },
        { name: "Sürətli axtarış", value: "/common/fastsearch", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sürətli axtarış</h2>
                    <p>
                        Məhsullar və anbar qalığı səhifəsində sürətli axtarışla məhsulun adı, barkodu, art kodu, şərhinə görə axtarış etmək üçün nəzərdə
                        tutulub. Digər sənədlər olan səhifələrdə isə, sənəd nömrəsinə görə axtarış üçün nəzərdə tutulub. Axtarış xanasına yazılan son hərfdən
                        dərhal sonra axtarma əməliyyatı icra olunur. Əlavə heç bir düyməni sıxmağa ehtiyac qalmır.
                    </p>
                    <img src="/images/common/fastsearch.gif" alt="Sürətli axtarış" />
                </article>
            </div>
        </div>
    );
};
